import { useState, useEffect } from 'react';
import { UserConnection } from 'services/auth/auth.types';
import { useGetAllConnectionsMutation } from 'services/user/user.endpoint';
import { useApiToast } from 'components/Toaster';
export const useConnections = () => {
    const [connections, setConnections] = useState<Array<UserConnection>>([]);
    const { showErrorToast } = useApiToast();

    const [
        getAllConnections,
        {
            isLoading: isGetAllConnectionsLoading,
            isError: isGetAllConnectionsError,
            isSuccess: isGetAllConnectionsSuccess,
            error: getAllConnectionsError,
            data: getAllConnectionsData
        }
    ] = useGetAllConnectionsMutation();
    
    useEffect(() => {
        getAllConnections(undefined);
    }, [getAllConnections]);

    useEffect(() => {
        if (isGetAllConnectionsLoading) return;
        if (isGetAllConnectionsError && getAllConnectionsError) {
            showErrorToast(getAllConnectionsError, {
                message: 'Erreur de chargement des dernièresconnexions'
            });
            return;
        }
        if (isGetAllConnectionsSuccess && getAllConnectionsData) {
            setConnections(getAllConnectionsData.data);
            return;
        }
    }, [isGetAllConnectionsLoading, isGetAllConnectionsError, isGetAllConnectionsSuccess, getAllConnectionsError, getAllConnectionsData]);

    return {
        connections,
        isGetAllConnectionsLoading
    };
};